var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 5H7C4.79086 5 3 6.79086 3 9V17C3 19.2091 4.79086 21 7 21H15C17.2091 21 19 19.2091 19 17V13",
  stroke: "#18372A",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.0001 7.6213L10.3537 16.2678C10.1661 16.4553 9.91178 16.5607 9.64656 16.5607H8.43945C8.16331 16.5607 7.93945 16.3368 7.93945 16.0607L7.93945 14.8536C7.93945 14.5883 8.04481 14.334 8.23235 14.1465L16.8788 5.49998L19.0001 7.6213Z",
  fill: "#18372A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5607 5.06066C22.1464 4.47487 22.1464 3.52513 21.5607 2.93934C20.9749 2.35355 20.0251 2.35355 19.4393 2.93934L21.5607 5.06066ZM18.9393 3.43934L17.8787 4.5L20 6.62132L21.0607 5.56066L18.9393 3.43934ZM21.0607 5.56066L21.5607 5.06066L19.4393 2.93934L18.9393 3.43934L21.0607 5.56066Z",
  fill: "#18372A"
}));
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b44fb0ee2e81325f49d7ad09db8a0b04.svg";
export { ForwardRef as ReactComponent };